import React from 'react';
// logic
import useTicketFormSettings from '../components/ticketForm/useTicketFormSettings';
import useNewTicket from '../components/newTicket/useNewTicket';
// components
import PortalContent from '../components/ui/portal/portalContent';
import NewTicketToolbar from '../components/newTicket/newTicketToolbar';
import TicketForm from '../components/ticketForm/ticketForm';
import BasicLoader from '../components/ui/loaders/basicLoader';

const NewTicketPage = () => {
  const { isLoadingTicketFormSettings, ticketFormSettings } = useTicketFormSettings();
  const { onSubmit, onCancel, validationSchema, initialValues, isReadOnly, isEdit } =
    useNewTicket();

  const ticketFormData = {
    ticketFormSettings,
    validationSchema,
    initialValues,
    isReadOnly,
    isEdit,
    onSubmit,
    onCancel,
  };

  return (
    <>
      <PortalContent>
        <NewTicketToolbar />
      </PortalContent>
      {isLoadingTicketFormSettings ? (
        <BasicLoader />
      ) : (
        <TicketForm ticketFormData={ticketFormData} />
      )}
    </>
  );
};

export default NewTicketPage;
